import { Badge, Button, Card, Container, Form, Modal, Tab, Tabs } from "react-bootstrap";
import Banner from "../components/Banner";
import BreadcrumbBar from "../components/Breadcrumb";
import { SlPencil } from "react-icons/sl";
import { useState } from "react";
import ProfileBackgoundImage from "../assets/images/banner-dummy-image.png";
import ProfileImage from "../assets/images/profile-dummy.svg";
import { GrLocation, GrMailOption } from "react-icons/gr";
import About from "../components/About";
import BillingInformations from "../components/BillingInformations";
import Reports from "../components/Reports";
import { PiCameraFill } from "react-icons/pi";
import { useParams } from "react-router-dom";
import AuthorProfile from "../components/AuthorProfile";
import TopBadge from "../assets/images/badge.svg";
import Follow from "../assets/images/add-friend.svg";


export default function Profile() {
  const [coverImage, setCoverImage] = useState(ProfileBackgoundImage);
  const [profileImage, setProfileImage] = useState(ProfileImage);
  const [coverImageFile, setCoverImageFile] = useState(null);
  const [image, setImage] = useState(); // Default image
  const [rawImage, setRawImage] = useState(null);
  const [modalShow, setModalShow] = useState(false);
  const [formData, setFormData] = useState({
    image: "",
    name: "",
    email: "",
    bio: ""
  });
  const [errors, setErrors] = useState({});
  const { id } = useParams();
  
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleCoverChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setCoverImageFile(file);
      setCoverImage(URL.createObjectURL(file));
    }
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith("image")) {
      const reader = new FileReader();
      reader.onload = () => {
        setRawImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <>
      <Banner
        heading="Profile"
        description="Type a disease, keyword, or question and explore easy-to-read research summaries made just for you."
      />
      <BreadcrumbBar
        items={[{ label: "Home", href: "/" }, { label: "Profile" }]}
      />
      <Container>
        <div className="profile-outer-box">
          <div className="profile-content">
            <div className="profile">
              {/* Cover Image Section with "Change Cover Photo" button */}
              <div className="cover-image ">
                <img src={coverImage} alt="Cover" className="w-100" />

                {/* Show "Change Cover Photo" only if it's the logged-in user */}
                {/* {userData?.username === user?.username && ( */}
                {
                  id == undefined ?
                    <div className="change-cover-btn">
                      <input
                        type="file"
                        id="coverUpload"
                        accept="image/*"
                        onChange={handleCoverChange}
                        hidden
                      />
                      <label htmlFor="coverUpload" className="change-cover-icon">
                        <SlPencil />
                      </label>
                    </div>
                    : ""}
                {/* )} */}
              </div>
              <div className="profile-img">
                <div className="user-img mx-auto">
                  <img className="img-fluid" src={profileImage} alt="" />
                </div>
                <div className="profile-details mx-auto">
                  <h5>Andrew Robinson</h5>
                  {
                    id == undefined ?
                      <a href="#">
                        <p className="mb-2">
                          <GrMailOption />
                          Jenniferadams@gmail.com
                        </p>
                      </a> : ""
                  }
                  <p className="mb-0">
                    <GrLocation />
                    Guttenberg, NJ, United States
                  </p>
                </div>
                {
                  id ?
                  <div className="contibutor-tag text-center">
                    <Badge>
                      <img src={TopBadge} alt="" className="me-2"/>
                      Top Contributor
                    </Badge>
                    <Badge>
                      <img src={Follow} alt="" className="me-2"/>
                      FollowThe Author
                    </Badge>
                  </div> 
                  : ""
                }
                {
                  id == undefined ?
                    <Button variant="outline-secondary" className="edit-btn" onClick={() => setModalShow(true)}>
                      <SlPencil />
                    </Button> : ""}
              </div>
            </div>
            {
              id ? (
                <AuthorProfile />
              )
                : <Tabs defaultActiveKey="about" className="justify-content-center">
                  <Tab eventKey="about" title="About">
                    <About
                      show={modalShow}
                      hide={setModalShow}
                    />
                  </Tab>
                  <Tab eventKey="billing" title="Billing Information">
                    <BillingInformations />
                  </Tab>
                  <Tab eventKey="reports" title="Saved Reports">
                    <Reports />
                  </Tab>
                </Tabs>
            }
          </div>
        </div>
      </Container>

      <Modal
        //   {...props}
        show={modalShow}
        onHide={() => setModalShow(false)}
        centered
        className="cancel-modal profile-modal"
      >
        <Modal.Header closeButton className="border-bottom-0 p-0">
        </Modal.Header>
        <Modal.Body className="p-0">
          <Modal.Title>
            Edit Profile Informations
          </Modal.Title>
          <p className="sub-des">Edit your profile details.</p>
          <Card className="mb-1 mt-4">
            <Card.Body>
              <Form className="form login-form">
                <Form.Group className="mb-4 mt-3">
                  <Form.Label>Profile Photo</Form.Label>
                  <div className="profile-container">
                    <div className="profile-wrapper">
                      <img src={image || ProfileImage} alt="Profile" className="profile-image" />
                      <label htmlFor="fileInput" className="upload-icon">
                        <PiCameraFill />
                      </label>
                      <Form.Control
                        type="file"
                        id="fileInput"
                        accept="image/*"
                        onChange={handleImageChange}
                        className="file-input"
                      />
                    </div>
                  </div>
                </Form.Group>
                <Form.Group className="mb-4">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    placeholder="Enter name"
                    value={formData.name}
                    onChange={handleChange}
                    isInvalid={!!errors.name} // Ensure invalid state is set for name
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.name}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="mb-4">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="text"
                    name="email"
                    placeholder="Email address"
                    value={formData.email}
                    onChange={handleChange}
                    isInvalid={!!errors.email} // Ensure invalid state is set for email
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.email}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Bio</Form.Label>
                  <Form.Control
                    type="text"
                    name="bio"
                    placeholder="Bio"
                    value={formData.bio}
                    onChange={handleChange}
                    isInvalid={!!errors.bio} // Ensure invalid state is set for email
                    as="textarea"
                    rows={3}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.bio}
                  </Form.Control.Feedback>
                </Form.Group>
              </Form>
            </Card.Body>
          </Card>
        </Modal.Body>
        <Modal.Footer className="p-0 border-top-0">
          <Button variant="outline-secondary" onClick={() => setModalShow(false)}>Close</Button>
          <Button variant="primary">Save</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
